/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Access_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update model access. Please try again." |
*
* @param {Model_Access_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_access_save_error = /** @type {((inputs?: Model_Access_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Access_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Modellzugriff konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update model access. Please try again.")
});